import { newNanoId } from "../../helper/idHelper";

class PreLayoutContent {
  constructor(props) {
    const { powerNets, referenceNets, components, decapGroups = [], balls = {}, nets = [], voltages = {}, model = {} } = props;
    this.powerNets = powerNets;
    this.referenceNets = referenceNets;
    this.components = components;
    this.decapGroups = decapGroups;
    this.balls = balls || {};
    this.voltages = voltages;
    this.nets = nets;
    this.model = model || {};
  }
}

class PreLayoutComponent {
  constructor(props) {
    const { name, type, pins, model } = props;
    this.name = name;
    this.type = type;
    this.pins = pins;
    this.model = model || {};
    this.voltage = "";
  }
}

class DCPreComponent {
  constructor(props) {
    const { name, type, pins, value, id, row, column } = props;
    this.id = id
    this.name = name;
    this.type = type;
    this.pins = pins;
    this.value = value || "";
    this.row = row;
    this.column = column;
  }
}

class DecapGroup {
  constructor(props) {
    const { name = "", powerNet = "", referenceNet = "", l_group = "", r_group = "", decaps = [] } = props;
    this.name = name;
    this.powerNet = powerNet;
    this.referenceNet = referenceNet;
    this.l_group = l_group;
    this.r_group = r_group;
    this.decaps = decaps
  }
}

class Decap {
  constructor(props) {
    const { name, number, l_layout = "", r_layout = "", model = {} } = props;
    this.id = newNanoId(8);
    this.name = name;
    this.number = number;
    this.l_layout = l_layout;
    this.r_layout = r_layout;
    this.model = model
  }
}

class PreLayoutBall {
  constructor(props) {
    const { l = "", r = "", c = "" } = props;
    this.l = l;
    this.r = r;
    this.c = c
  }
}
class PreLayoutModel {
  constructor(props) {
    const { files = [], ports = [], powerNets = [] } = props || {};
    this.files = files;
    const _ports = [];
    for (let i = 0; i < powerNets.length; i++) {
      const net = powerNets[i];
      const port = ports.find(p => p.powerNet === net);
      _ports.push(new PreLayoutPorts(port || { powerNet: net }));
    }
    this.ports = _ports;
  }
}

class PreLayoutPorts {
  constructor(props) {
    const { powerNet = '', icPorts = [], pmicPorts = [] } = props || {};
    this.powerNet = powerNet;
    this.icPorts = icPorts.length > 0 ? icPorts : [{ port: '1' }];
    this.pmicPorts = pmicPorts.length > 0 ? pmicPorts : [{ port: '1' }];
  }
}

export {
  PreLayoutContent,
  PreLayoutComponent,
  DecapGroup,
  Decap,
  PreLayoutBall,
  DCPreComponent,
  PreLayoutModel
}